// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list, $delete, update, createOrUpdate, get } from "./operations.js";
export {
  GroupQuotasListOptionalParams,
  GroupQuotasDeleteOptionalParams,
  GroupQuotasUpdateOptionalParams,
  GroupQuotasCreateOrUpdateOptionalParams,
  GroupQuotasGetOptionalParams,
} from "./options.js";
